<template>
    <article :id="`review-${quote.id}`" class="review-card">
        <div class="review-card-media">
            <UiImage :src="quote?.media[0].webp" :classes="'responsive full'" />
        </div>
        <div class="review-card-content" v-html="props.quote?.body" />
        <div class="review-card-info">
            <div class="who">{{ quote.from }}</div>
            <div class="from">{{ quote.who }}</div>
        </div>
    </article>
</template>

<script setup lang="ts">
const props = defineProps({
    quote: {
        type: Object,
        default: () => ({})
    }
});
</script>
